import "./UserOrInviteAvatar.scss";

import { Invite, User } from "../../../lib/types/UserTypes";
import { getDriverKey, isUser } from "../../../lib/util/UserUtils";
import Avatar from "../../common/Avatar/Avatar";
import React, { useMemo } from "react";
import { IconInvitedAvatar, IconInvitedError } from "../../../assets";
import {
	useFormatUserEmail,
	useFormatUserName,
} from "../../../lib/hook/FormatHooks";
import clsx from "clsx";

export interface UserOrInviteAvatarProps {
	userOrInvite: User | Invite;
	size: number;
}

export const UserOrInviteAvatar = (props: UserOrInviteAvatarProps) => {
	const { userOrInvite, size } = props;
	const key = getDriverKey(userOrInvite);
	const name = useFormatUserName()(userOrInvite);
	const email = useFormatUserEmail()(userOrInvite);
	const containerStyle = useMemo(
		() => ({ width: `${size}px`, height: `${size}px` }),
		[size],
	);
	const inviteStyle = useMemo(
		() => ({ width: `${size * 1.133}px`, height: `${size * 1.133}px` }),
		[size],
	);

	if (isUser(userOrInvite)) {
		return (
			<Avatar
				className={"UserOrInviteAvatar"}
				guid={key}
				size={size}
				name={name ? name : email}
			/>
		);
	}

	const undelivered = userOrInvite.deliveryFailed === true;
	return (
		<div
			style={containerStyle}
			className={clsx(
				"UserOrInviteAvatar",
				undelivered && "UserOrInviteAvatar--error",
			)}
		>
			{undelivered ? (
				<IconInvitedError
					key={Boolean(undelivered).toString()}
					style={inviteStyle}
				/>
			) : (
				<IconInvitedAvatar
					key={Boolean(undelivered).toString()}
					style={inviteStyle}
				/>
			)}
		</div>
	);
};

export default UserOrInviteAvatar;
